import InfoIcon from "@mui/icons-material/InfoOutline";
import {
  Box,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Radio,
  RadioGroup,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";
import { booleanToString, stringToBoolean } from "helpers";
import { Controller, useFormContext } from "react-hook-form";
import { UserProfileFormData } from "validations/userSchemas";

const PracticeUserAccountStatusSection: React.FC = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<UserProfileFormData>();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        mt: 4,
        position: "relative",
        zIndex: 1,
      }}
    >
      <Typography variant="h6" sx={{ fontSize: "1.25rem", fontWeight: 500 }}>
        Account Status
      </Typography>

      <FormControl component="fieldset" error={Boolean(errors.isActive)}>
        <Controller
          name="isActive"
          control={control}
          render={({ field }) => {
            const stringValue = booleanToString(field.value);

            return (
              <RadioGroup
                name="isActive"
                value={stringValue}
                onChange={(e) => {
                  const boolValue = stringToBoolean(e.target.value);
                  field.onChange(boolValue);
                }}
                row
              >
                <Box>
                  <FormControlLabel
                    value="true"
                    control={<Radio />}
                    label={
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                      >
                        <span>Active</span>
                        <Tooltip
                          title="The user will be able to use the platform"
                          arrow
                          placement="right"
                        >
                          <InfoIcon
                            fontSize="small"
                            sx={{
                              color: "text.secondary",
                              cursor: "help",
                              "&:hover": {
                                color: "primary.main",
                              },
                            }}
                          />
                        </Tooltip>
                      </Box>
                    }
                  />
                  <FormControlLabel
                    value="false"
                    control={<Radio />}
                    label={
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                      >
                        <span>Inactive</span>
                        <Tooltip
                          title="The user will NOT be able to use the platform"
                          arrow
                          placement="right"
                        >
                          <InfoIcon
                            fontSize="small"
                            sx={{
                              color: "text.secondary",
                              cursor: "help",
                              "&:hover": {
                                color: "primary.main",
                              },
                            }}
                          />
                        </Tooltip>
                      </Box>
                    }
                  />
                </Box>
              </RadioGroup>
            );
          }}
        />
        {errors.isActive && (
          <FormHelperText>{errors.isActive.message}</FormHelperText>
        )}
      </FormControl>
    </Box>
  );
};

export default PracticeUserAccountStatusSection;
